export default __webpack_public_path__ + "static/media/3-dots.4d1144f6.svg";